export function getVideoDuration(fileOrBlob) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(fileOrBlob);
    const video = document.createElement("video");

    video.preload = "metadata";
    video.onloadedmetadata = () => {
      const duration = video.duration;
      URL.revokeObjectURL(url);
      if (Number.isFinite(duration)) {
        resolve(duration);
      } else {
        reject(new Error("No se pudo obtener la duración del video"));
      }
    };
    video.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Error cargando metadata del video"));
    };

    video.src = url;
  });
}